








































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import Header from "@/components/Header.vue";
import requestService from "@/service/requestService";
import { MESSAGE } from "@/model/Message";
import { Utils } from "@/service/util";
import { ElInput } from "element-ui/types/input";
import Number from "@/shared/filters/Number";
import ReservationDetailState from "@/store/reservation/state";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
@Component({
  components: {
    Header,
    ConfirmDialog,
  },
  filters: {
    Number
  }
})
export default class ReferReservation extends Vue {
//  @Prop() torokubangoSelected = "";
  // 車検識別する最初のページ=起点画面で呼び出された場合は動作が異なる
  @Prop({ default: false }) frontPage: boolean; 

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("currentState", { namespace: "ReservationDetail" })
  currentState: ReservationDetailState;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;

//  kbnJidousha: any = [];
  data: any = [];
  dataPageList: any = [];
  dataCnt: number = 0;
  currentPage = 1;
  pageSize = 10;
  currentRow: any = {};
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  chkReservations: number = 0;
  // confirmDialogNexInspectMsg: string = "";
  showDialogReferResevation: boolean = false;
  dialogNex: boolean=false;
  dialog2Nex: boolean=false;

  copyReservationStepUp: number = 0;
  copyReservationStepOver: number = 0;

  fromResevation: any = [];
  toResevation: any = [];

  public reqService: requestService = new requestService();
  public utils: Utils = new Utils();

  form: any = {
    searchFrom: null,
    searchTo: null,
    plateNo: null,
    kokyakuNm: null,
    quickMitsumoriId: null
  };

  $refs!: {
    refIptPlateNo: ElInput
    sendNexDialog: ConfirmDialog;
  //  sendNexDialogEnd: ConfirmDialog;
    referReservationDialog: ConfirmDialog;
  };
  created() {
    // 
  }

  mounted() {
  //  if ( this.uketsukeExtendsId != null ) {
  //    // this.$set(this, "loading", true);
  //    this.getReferReservation(this.uketsukeExtendsId);
  //  }
    
  }

  open() {
    this.$set(this, "loading", true);
    this.showDialogReferResevation = true;
    if ( this.uketsukeExtendsId != null ) {// 複製可能データのロード
      // this.$set(this, "loading", true);
      this.getReferReservation(this.uketsukeExtendsId);
    }
  }

// 選択を押すと数値を保存、違う通知を持つチェックボックスをdisable
// 配列をぐるっと回して同じidのチェックボックスをチェック
// 各配列のチェックフラグをON/OFF
  getReferReservation(uketsukeExtendsId: number) {
    this.reqService.getReferReservation(
      uketsukeExtendsId,
      this.isNextageCustom? this.currentState.uketsuke.nyuukoPlansYmd: this.currentState.uketsuke.workPlansYmd,
      this.customerCar.shadaiNo
    ).then(
      (res: any) => {
        if (res) {
          this.convertData(res); // 表示用に加工する
        } else {
          this.$set(this, "loading", false);
  //      this.searchQuick(this.form);
        }
      },
      (err: any) => {
        this.$set(this, "loading", false);
      }
    );
  }

  convertData(res: any) {
    // 引用元リスト用に加工する
    let i: number = 0;
    let dispOnlyCnt: any = [];
    let j: number = 0;
    // let j: number = 0; // iキャッシュ
    // let k: number = 0; // j->iカウンタ
    // let l: number = 0; // pearentキャッシュ
    // let m: number = 0; // rowcntカウンタ
    // let n: number = 0; // rowcnt総計
    // let rowcnt: boolean = false;
    for ( i=0; i < res.length ; i++ ) {

    //  // 複数見積もりの縦結合
    //  if ( rowcnt == false && res[i].uketsukeParentNo != "" ) {
    //    // 縦の結合サイズ調査開始
    //    rowcnt = true;
    //    j=i;
    //    l=res[i].uketsukeParentCd;
    //    m++;
    //  } else if (rowcnt == true) {
    //    if ( res[i].uketsukeParentNo == "" ) {
    //      // 縦の結合領域を抜けたので調整実行
    //      rowcnt = false;
    //      res[j].rowstart = true; // 始点の更新
    //      for ( k= this.utils.this.utils.deepCopy(j); k < i ; k++ ) {
    //        res[k].rowcnt = m; // カウンタの更新
    //        res[k].no = i - m - n + 1; // 表示番号上書き
    //      }
    //      n=n+m-1; // 総計に移してカウンタは初期化
    //      m=0;
    //      j=0;
    //    } else if ( l!=res[i].uketsukeParentCd ) {
    //      // 次の縦の結合領域に入っているので調整実行して、次のサイズ調査開始
    //      res[j].rowstart = true; // 始点の更新
    //      for ( k=this.utils.this.utils.deepCopy(j); k < i ; k++ ) {
    //        res[k].rowcnt = m; // カウンタの更新
    //        res[k].no = i - m - n + 1; // 表示番号上書き
    //      }
    //      j=i;
    //      l=res[i].uketsukeParentCd;
    //      n=n+m-1; // 総計に移してカウンタは初期化
    //      m=1; // 0で初期化して直後にインクリメント
    //    } else {
    //      // 縦の結合調査中
    //      m++;
    //    }
    //  }

      // 表示用のカラムの追加
      res[i].ischeck = false; // チェックボックス用
      j = res[i].no * 1; // 何度も使うので格納
      if ( dispOnlyCnt.length < j ) { dispOnlyCnt[j-1] = 0; }
      if ( this.dataCnt < j ) { this.dataCnt = j; }
      if ( res[i].dispOnly == 1 )  { dispOnlyCnt[j-1] = dispOnlyCnt[j-1] + 1; }
    }

    // 操作不能件数を各セルに埋め込み
    for ( i=0; i < res.length ; i++ ) {
      res[i].onlycnt = dispOnlyCnt[(res[i].no * 1)-1];
    }

    // 対象が一つしかない場合はチェック状態にする
    if ( this.dataCnt == 1 && dispOnlyCnt[0] == 0 ) {
      for ( i=0; i < res.length ; i++ ) {
        res[i].ischeck = true;
        this.chkReservations = 1;
      }
    }
    this.data = res;
    this.setDataPage();
  }

  setDataPage() {
    // データ数でのページング
    const iStart = (this.currentPage - 1) * this.pageSize;
    const iStop = iStart + this.pageSize;
    // const data = this.data.slice(iStart, iStop);

    // 結合を意識したブロック数の処理に変換する
    let i = 0;
    let j = 0;
    for ( i=0; i < this.data.length ; i++ ) {
      if ( this.data[i].no > iStart ) {
        for ( j=i; j < this.data.length ; j++ ) {
          if ( this.data[j].no > iStop ) { break; }
        }
        if ( j == i ) { j = this.data.length; } // 最終ページの補完
        break;
      }
    }
    const data = this.data.slice(i, j);

    this.$set(this, "dataPageList", data);
    
    if (this.loading) {
      this.$set(this, "loading", false);
    }
  }

  heiseiDate(date: string) {
    if (date) {
      let str = this.utils.getJapanDate(date, "YYYYMMDD");
      // return str.replace(" ", "<wbr/>");
      return str;
    }
    return "";
  }

  // ページネーション
  handleCurrentChange() {
    this.setDataPage();
  }

  onConfirm() {
    this.$router.push({ name: "quickseibilist" });
    this.data = [];
  }

  onRowSelect(row: any, event: any, columnIndex: any) {
  //  console.log("maki",row);
  //  console.log("maki2",columnIndex);
  //  if ( row.no == this.chkReservations ) {
  //    row.ischeck = !row.ischeck;
   // }
  //  if (this.torokubangoSelected !== row.sknQuickMitsumoriId) {
  //    // this.torokubangoSelected = row.torokubango;
  //    this.$emit("onSelectCurrentRow", row);
  //  } else {
  //    this.$emit("onSelectCurrentRow");
  //    // this.torokubangoSelected = "";
  //  }
  }

  tableRowClassName(item: any) {
    if ( item.row.dispOnly == 1 ) { return "disp-only"; }
  }

  // 選択ボタンの動作
  selectReservations( no: number ) {
    let i = 0;
    let j = 0;
  //  for ( i=0; i < this.data.length ; i++ ) {
  //    this.data[i].ischeck = false
  //    if ( this.data[i].no == no ) this.data[i].ischeck = true;
  //  }
    for ( i=0; i < this.dataPageList.length ; i++ ) {
      this.dataPageList[i].ischeck = false;
      if ( this.dataPageList[i].no == no && this.dataPageList[i].dispOnly!=1 ) {
        this.dataPageList[i].ischeck = true;
        j = no;
      }
    }
    this.chkReservations = j; // no格納して選択状態にする。有効データが無ければキャンセル
  //  this.$emit("selected");
  }


  objectSpanMethod(obj: any) {
    let columnIndex: number = obj.columnIndex;
    let rowCnt: number = obj.row.rowCnt;
    let rowStart: number = obj.row.rowStart;
    // console.log(obj);
    if ( rowCnt > 1 ) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 3 
        || columnIndex === 4 || columnIndex === 5
      ) {
        if (rowStart == 1 ) {
          // 縦結合
          return {
            rowspan: rowCnt,
            colspan: 1,
          };
        } else {
          // 表示省略
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    }
  }

  destroyed() {
    this.currentRow = {};
    this.data = [];
  }

  get customerCar() {
    if (this.currentState && this.currentState.customerCar) {
      return this.currentState.customerCar;
    }
    return {};
  }

  closeDialog() {
    this.selectReservations(0); // 全チェック初期化
    this.showDialogReferResevation = false;
  }


  onCopyReferReservation() {


    this.toResevation = [];
    this.fromResevation = [];

    this.toResevation.push(this.uketsukeCd);// 参照先

    let i = 0;
    for ( i=0; i < this.data.length ; i++ ) {
      if ( this.data[i].ischeck == true ) {
        this.fromResevation.push(this.data[i].uketsukeCd);// 参照元
      }
    }

    this.copyReservationStepUp = 0;
    this.copyReservationStepOver = 0;
    let beforeCnt = 0;

    if ( this.toResevation.length != this.fromResevation.length ) {
      // サイズが違う＝事前にコピーが必要
      beforeCnt = this.fromResevation.length - this.toResevation.length;
      this.copyReservationStepOver += beforeCnt;
    }

    // コピーの件数だけ待ちが発生する
    this.copyReservationStepOver += this.fromResevation.length;

    this.dialogNex = true;
  // /  this.confirmDialogNexInspectMsg = "選択した見積内容を引用します<br>よろしいですか？";
  //  this.$refs.sendNexDialog.onOpen();
  }

  // 過去参照複製 ( Step:"1" loading:"false" ) - 複製開始
  exitReferReservation() {
    this.dialogNex = false;
    this.$set(this, "loadingText" , MESSAGE.Loading + "   (" 
      + this.copyReservationStepUp + "/" + this.copyReservationStepOver + ")");
    if ( this.toResevation.length != this.fromResevation.length ) {
      this.$set(this, "loading", true);
      // サイズが違う＝事前にコピーが必要
      this.beforeCopyPromise(); // step2: コピー実行、管理
    } else {
      this.$set(this, "loading", true);
      this.referCopyPromise(); // step3: コピー実行、管理
    }
  }

  // 過去参照複製 ( Step:"2" loading:"true" ) - コピー枠用意、管理
  beforeCopyPromise() {
    let beforeCnt = this.fromResevation.length - this.toResevation.length;
    let promise = this.beforeCopy( this.uketsukeCd , beforeCnt , 1 );
    Promise.all([promise]).then(() => {
      this.referCopyPromise(); // step3: コピー実行、管理
    });
  }

  // 過去参照複製 ( Step:"3" loading:"true" ) - コピー実行、管理
  referCopyPromise() {
    let promise = this.referCopy( this.fromResevation , this.toResevation , 0 );
    Promise.all([promise]).then(() => {
      this.dialog2Nex = true; // Step4before: コピー先の画面に切り替える
      // this.selectScenario( this.toResevation[0] ); // Step4: コピー先の画面に切り替える
    });

    // 並行処理版：トランザクションの再開エラーが出る
    /*let arrPromises: any[] = Array();
    for (let index=0; index < this.fromResevation.length; index++) {
      if ( this.fromResevation[index] != "" && this.toResevation[index] != "" ) {
        let promise = this.referCopyTest( this.fromResevation[index] , this.toResevation[index] );
        if (promise) {
          arrPromises.push(promise);
        }
      }
    }
    Promise.all(arrPromises).then((ret)=> {
      if (ret) {
        console.log(ret);
        this.dialog2Nex = true; // Step4before: コピー先の画面に切り替える
      }
    }, err => {});*/
  }

  // 過去参照複製 ( Step:"4" loading:"true" ) - コピー先の画面に切り替える
  selectScenario(uketsukeCd: string) {
    this.$set(this, "loading", false);
    // 今開いているページに飛ぶのでrouterが動作しない→強制再読み込み
    /*this.$set(this, "loading", true);
    this.reqService.changeReservationTarget(uketsukeCd).then(
      (res: any) => {
        this.$set(this, "loading", false);

        if ( this.frontPage ) {
          // 同じページに飛ぶのでhistoryを汚さないようにする
          this.$router.replace({
            name: "customer",
            params: { code: res.uketsuke.uketsukeCd }
          });
        } else {
          this.$router.push({
            name: "customer",
            params: { code: res.uketsuke.uketsukeCd }
          }); 
        }
      },
      (err: any) => {
        this.$set(this, "loading", false);
      }
    );*/
    // 強制再読み込み
    window.location.reload();
  }

  // コピー先を必要分、複製用意する   【再起呼出】
  beforeCopy(UketsukeCd: string , Line: number , cnt: number ) {
    const promise = new Promise((resolve, reject) => {
      this.reqService.copyReservationTarget(UketsukeCd,"").then(
        (res: any) => {
          this.copyReservationStepUp++;
          this.toResevation.push(res.uketsuke.uketsukeCd);// 参照先追加
          this.$set(this, "loadingText" , MESSAGE.Loading + "   (" 
            + this.copyReservationStepUp + "/" + this.copyReservationStepOver + ")");
          if ( Line > cnt ) {
            if ( this.copyReservationStepUp >= this.copyReservationStepOver ) {
              resolve(); // Step4before: コピー先の画面に切り替える(永続ロードの回避Ver)
            }
            // let promiseSub = this.beforeCopy( res.uketsuke.uketsukeCd , Line , cnt + 1 );// 再起呼出
            let promiseSub = this.beforeCopy( UketsukeCd , Line , cnt + 1 );// 再起呼出 複製元を合わせないと親設定が狂う
            Promise.all([promiseSub]).then(() => {
              resolve();
            });
            
          } else {
            resolve();
          }
        },
        (err: any) => {
          resolve();
        }
      );
    });
    return promise;
  }

  // コピー元リストからコピー先リストに複製を行う   【再起呼出】
  referCopy( fromResevation: any , toResevation: any , cnt: number ) {
    const promise = new Promise((resolve, reject) => {
      if ( fromResevation[cnt] != "" && toResevation[cnt] != "" ) {
        this.reqService.copyReservationTarget(fromResevation[cnt] , toResevation[cnt] ).then(
          (res: any) => {
            this.copyReservationStepUp++;
            this.$set(this, "loadingText" , MESSAGE.Loading + "   (" 
              + this.copyReservationStepUp + "/" + this.copyReservationStepOver + ")");
            if ( toResevation.length > cnt + 1 ) { // 次のデータの存在確認
              if ( this.copyReservationStepUp >= this.copyReservationStepOver ) {
                resolve();
              }
              let promiseSub = this.referCopy( fromResevation , toResevation , cnt + 1 );// 再起呼出
              Promise.all([promiseSub]).then(() => {
                resolve();
              });
            } else {
              resolve();
            }
            
          },
          (err: any) => {
            this.$emit("onError", err);
            reject();
          }
        );
      } else {
        resolve();
      }
      
    });
    return promise;
  }

  // コピー元リストからコピー先リストに複製を行う   【並行処理】トランザクションエラーが出る。おそらく処理速度
  referCopyTest( fromResevation: string , toResevation: string ) {
    const promise = new Promise((resolve, reject) => {
        this.reqService.copyReservationTarget(fromResevation , toResevation ).then(
          (res: any) => {
            this.copyReservationStepUp++;
            this.$set(this, "loadingText" , MESSAGE.Loading + "   (" 
              + this.copyReservationStepUp + "/" + this.copyReservationStepOver + ")");
            resolve();
          },
          (err: any) => {
            resolve();
          }
        );
      
    });
    return promise;
  }
}
